import * as React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

/**
 * Full-screen loading indicator
 * Used during app bootstrap and other loading states
 */
export default function LoadingScreen({ message = 'Loading...' }) {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                zIndex: theme => theme.zIndex.modal + 1,
                bgcolor: 'background.default',
            }}
        >
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">
                {message}
            </Typography>
        </Box>
    )
}
